import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { requiredAtLeastThreeValidator } from '@app/associate/uploaded-doc-list/requiredAtLeastThree';
import { associateDocList } from '@app/_models/associateDocList';
import { AssociateService } from '@app/_services/associate.service';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { LogService } from '@app/_shared/log.service';
import { environment } from '@environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { NgxSpinnerService } from "ngx-spinner";
const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMMM/YYYY',
  },
  display: {
    dateInput: 'MMMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-uploaded-doc-list',
  templateUrl: './uploaded-doc-list.component.html',
  styleUrls: ['./uploaded-doc-list.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class UploadedDocListComponent implements OnInit {

  date = new FormControl(moment());

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);

  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    let ea = this.uploadDocAssociateForm.controls.myCheckboxGroup
    let b = ea.get("passingYear").setValue(this.date.value)
    this.monthyearIsSelect = true;
  }

  dateFilter = (d: any): boolean => {
    const day = d.year();
    var val = [];
    this.YearOfPassDropDown.forEach((keys: any, vals: any) => {
      var x = keys.yearOfPassing;
      var y: number = +x;
      day !== y + "";
      val.push(y);
    })
    var alphaNumeric = val.join("  && day !== ");;
    var aq = (day !== + alphaNumeric);
    var stringValueYouWant = val.join();

    return stringValueYouWant.indexOf(d.year()) !== -1;
    //return aq;
  }

  fileURL;
  src;
  isUPdf;
  isUImage;
  streamDropDown = [];
  collegeDropDown = [];
  YearOfPassDropDown = [];
  branchDropDown = [];
  semesterDropDown = [];
  associateDocList = new associateDocList();
  request: associateDocList[];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  getId: number;
  docPath: string;
  upload_doc_path: any;
  submitted = false;
  title = 'docVerificationList';
  dtOptions: DataTables.Settings = {};
  getidVal: number;
  delMessage: string;
  getresponse: any;
  monthyearIsSelect = false;

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalDeleteBox', { read: TemplateRef }) showModalDeleteBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalBoxImage', { read: TemplateRef }) showModalBoxImage: TemplateRef<any>;

  get f() { return this.uploadDocAssociateForm.controls; }

  constructor(private verifyDocService: VerifyDocumentService, private associateService: AssociateService, private modalService: NgbModal, config: NgbModalConfig,
    private documentVerificationListService: DocumentVerificationListService,   private SpinnerService: NgxSpinnerService,private eventService: LogService) { }

  uploadDocAssociateForm = new FormGroup({

    // ...more form controls...
    myCheckboxGroup: new FormGroup({
      firstName: new FormControl(false),
      lastName: new FormControl(false),
      enrollmentNo: new FormControl(false),
      streamid: new FormControl(false),
      yearofpassid: new FormControl(false),
      collegenameid: new FormControl(false),
      stream: new FormControl(false),
      passingYear: new FormControl(false),
      collegeName: new FormControl(false),
      branch: new FormControl(false),
      semester: new FormControl(false),
      date: new FormControl(false),
      yearAndMonthSelect: new FormControl(false),
    }, requiredAtLeastThreeValidator()),
    // ...more form controls...

  });

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }
  passData(dataValue, data) {
    this.eventService.emit({ dataValue, data });
  }
  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    let ea = this.uploadDocAssociateForm.controls.myCheckboxGroup
    ea.get("passingYear").clearValidators()
    ea.get("passingYear").updateValueAndValidity();
    if (this.monthyearIsSelect) {
      var r = this.YearOfPassDropDown.find(x => x.yearOfPassing === this.date.value.year().toString());
      this.associateDocList.passingYearId = r.id,
        this.associateDocList.monthOfPassing = moment(this.date.value.month() + 1, 'MM').format('MMMM')
    }

    this.associateService.getAssociateDocList(this.associateDocList).pipe(first()).subscribe(
      (data) => {
        console.log(data);
        this.request = [];
        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
        //this.dtTrigger.next();
        console.log("Search Response", this.request)
      },
      (error) => {
        console.log(error.error);
        //alert(error.error);
      }
    );
    this.verifyDocService.getStreams()
      .pipe(first())
      .subscribe(
        data => {
          console.log("streams response---", data.respData)
          this.streamDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getColleges()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.collegeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getYearOfPassing()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("YearOfPassing response---", data.respData)
          this.YearOfPassDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )


  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
  searchData() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    let ea = this.uploadDocAssociateForm.controls.myCheckboxGroup
    ea.get("passingYear").clearValidators()
    ea.get("passingYear").updateValueAndValidity();
    if (this.monthyearIsSelect) {
      var r = this.YearOfPassDropDown.find(x => x.yearOfPassing === this.date.value.year().toString());

      this.associateDocList.passingYearId = r.id,
        this.associateDocList.monthOfPassing = moment(this.date.value.month() + 1, 'MM').format('MMMM')
    }
    this.associateService.getAssociateDocList(this.associateDocList).pipe(first()).subscribe(
      (data) => {
        console.log(data);
        this.request = data.respData;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          // Destroy the table first
          dtInstance.destroy();
          // Call the dtTrigger to rerender again
          this.dtTrigger.next();
        });

        //this.dtTrigger.next();
        console.log("Search Response", this.request)
      },
      (error) => {
        console.log(error.error);
        //alert(error.error);
      }
    );
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  openPdf() {
    window.open(this.fileURL);
  }

  openModal(id, originalDOCuploadfilePath) {
    // this.display = "block";    
    this.getId = id;
    this.docPath = originalDOCuploadfilePath;
    console.log(this.getId, this.docPath)
    this.upload_doc_path = '';
    this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + this.docPath).pipe(first())
      .subscribe(
        add => {
          console.log("addadd---", add)
          let reader = new FileReader();
          if (add.type == "application/pdf") {
            this.isUPdf = true;
            this.isUImage = false;
            reader.addEventListener("load", () => {
              this.upload_doc_path = reader.result;
              var base64Array = this.upload_doc_path.substring(28);
              console.log("=====base64Array===========", base64Array);
              this.src = this._base64ToArrayBuffer(base64Array);
              let file = new Blob([add], { type: 'application/pdf' });
              this.fileURL = URL.createObjectURL(file);
              // window.open(this.fileURL);                    
            }, false);
            // this.src = this._base64ToArrayBuffer();
          } else {
            this.isUImage = true;
            this.isUPdf = false;

            reader.addEventListener("load", () => {
              this.upload_doc_path = reader.result;
            }, false);
          }
          if (add) {
            this.SpinnerService.hide();
            this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
            reader.readAsDataURL(add);
          }
          if (this.isUPdf == true) {

            var al = window.open('', 'OPEN');
            window.setTimeout(function () { al.close() }, 100);
          }
        
        },error => {
          this.isUImage = true;
            this.isUPdf = false;
          this.SpinnerService.hide(); 
          this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
          this.upload_doc_path = "/University/assets/images/No-results-found.jpg"; // test server
          console.log(error)
        })
        this.SpinnerService.show();
  }

  delete1(id) {
    console.log(id)

    this.associateService.deleteDocById(id)
      .pipe(first())
      .subscribe(
        data => {
          if (data.respData == true) {
            alert('Record Deleted!');
          }
          // this.YearOfPassDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }

  getBranAndStream() {
    let id = Number(this.associateDocList.streamId);
    //alert(  Number(this.associateDocList.streamId));

    this.verifyDocService.getBranch(id)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.branchDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )


    this.verifyDocService.getSemester(id)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.semesterDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )
  }
  delete(id) {
    this.getidVal = id;
    this.modalService.open(this.showModalDeleteBoxTemplate);
  }

  deleteData() {
    this.associateService.deleteDocById(this.getidVal)
      .pipe(first())
      .subscribe(
        data => {
          this.getresponse = data;
          if (this.getresponse.respMessage == "Success") {
            this.delMessage = "Record Deleted Successfully."

            for (let i = 0; i < this.request.length; ++i) {
              if (this.request[i].id === this.getidVal) {
                this.request.splice(i, 1);
              }
            }
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.open(this.showModalBoxTemplate);
            // alert('Record Deleted!');
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.delMessage = this.getresponse.respData
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.dismissAll(this.showModalBoxTemplate);
          }
          // this.YearOfPassDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )



  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    // this.eventService.emit<string>('13');
  }
}
